import React from 'react';
import {DashboardView} from './container';

export const DashboardScreen = ({navigation}: {navigation: any}) => {
  return <DashboardView />;
};
